import { types } from 'mobx-state-tree';
import type { Instance } from 'mobx-state-tree';

export const ProfileDetailsOptionsModel = types.model('ProfileDetailsOptionsModel', {
    organizationSizes: types.frozen({}),
    jobTypes: types.frozen({}),
});

export type TypeProfileDetailsOptionsModel = Instance<typeof ProfileDetailsOptionsModel>;
export default ProfileDetailsOptionsModel;
